import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { closeCollapsible, isNullOrEmpty, translate, showMessageToastCustom } from '../../../utils/util';
import { Input, Button, Label } from '../../../components/UI/ComponentsUI';
import { onValueChange, validateInputsRequired } from '../../../utils/handleChangeHooks';
import StockService from '../../../services/StockService';
import CollapsibleUI from '../../../components/UI/CollapsibleUI';
import { ENUMS } from '../../../utils/constants';

const FilterJourneyMvm = (props) => {
    const [filter, setFilter] = useState(
        {
            journey: "",
            mvmNumber: ""
        });

    useEffect(() => {
        if((props.deem || props.sqp) && (props.update || props.sqp?.fromReceipt || props.deem?.fromReceipt)) { 
            let data = { 
                mvmNumber: props.type === ENUMS.eFormType.Deem.value? props.deem.mvmNumber : props.sqp.mvmNumber, 
                journey: props.type === ENUMS.eFormType.Deem.value ? props.deem.journey : props.sqp.journey,  
            }

            if(document.getElementById("mvmNumber")) {
                document.getElementById("mvmNumber").value = data.mvmNumber
                document.getElementById("journey").value = data.journey
            } 

            search(data);
        } else {
            if(document.getElementById("mvmNumber")) {
                document.getElementById("mvmNumber").value = ''
                document.getElementById("journey").value = ''
            } 
        }

        // eslint-disable-next-line
    }, []);    

    const getTransmissionLogFilter = () => { 
        if (validateInputsRequired("getDeemSqp")) { 
            search(filter)
        }
    }

    const search = (filter) => {
        props.searchMvmJoruney(filter, (data) => {
            if (props.callback && data) {
                setFilter({
                    journey: "",
                    mvmNumber: ""
                });
                props.callback(data);
                closeCollapsible("filterJourneyMvm");
            } else { 
                showMessageToastCustom(translate('warning', 'general'), "Nenhum registro foi encontrado", 8000, 'mdi mdi-alert-circle-outline red-text');
                if(props.update) props.history.go(-1);
            }
        });
    }

    const onChange = (event) => {
        onValueChange(event, filter, setFilter);
    };

    return (
        <div className="container" style={{ marginTop: '0px', }}>
            <CollapsibleUI
                id="filterJourneyMvm"
                header={translate('line-picking:linepicking.filter')}
                body={<> 
                        {props.update ? 
                        <div className="row" style={{ padding: '10px' }}>
                            <div className="input-field no-padding col s12 m4 l3">
                                <Label
                                    label={translate('stock:form.mvm')}
                                    value={(props.type === ENUMS.eFormType.Deem.value? props.deem?.mvmNumber : props.sqp?.mvmNumber) || '-'} 
                                />
                            </div>
                            <div className="input-field no-padding col s12 m4 l3">
                                <Label
                                    label={translate('stock:form.journey')}
                                    value={(props.type === ENUMS.eFormType.Deem.value? props.deem?.journey : props.sqp?.journey) || '-'} 
                                />
                            </div>
                        </div>
                        :
                        <>
                            <form id="getDeemSqp" className="col s12">
                                <div className="row" style={{ padding: '10px' }}>
                                    <div className="input-field no-padding  col s6">
                                        <Input
                                            required={isNullOrEmpty(filter?.journey)}
                                            //value={filter?.mvmNumber}
                                            type="text"
                                            label="Mvm"
                                            id="mvmNumber"
                                            name='mvmNumber'
                                            onChange={onChange}
                                            defaultValue={props.type === ENUMS.eFormType.Deem.value? props.deem?.mvmNumber : props.sqp?.mvmNumber} 
                                        />
                                    </div>
                                    <div className="input-field no-padding  col s5">
                                        <Input
                                            required={isNullOrEmpty(filter?.mvmNumber)}
                                        // value={filter?.journey}
                                            type="text"
                                            label="Viagem"
                                            id="journey"
                                            name='journey'
                                            onChange={onChange}
                                            defaultValue={props.type === ENUMS.eFormType.Deem.value? props.deem?.journey : props.sqp?.journey} 
                                        />
                                    </div>
                                </div>
                            </form>
                            <div className="row" style={{ paddingTop: '0px' }}>
                                <Button full="true" text="Buscar" onClick={() => getTransmissionLogFilter()} />
                            </div>
                        </>
                    } 
                </>}
            />
        </div>
    );
}

const mapStateToProps = (state) => {
    return {
        transmissions: state.truckKanbanReducer.transmissions, 
        deem: state.stockReducer.deem,
        sqp: state.stockReducer.sqp
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        searchMvmJoruney: (filter, callback) => {
            dispatch(StockService.searchMvmJoruney(filter, callback));
        },  
    }
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(FilterJourneyMvm)));
